<template>
  <div class="app">
    <main-menu/>
    <router-view/>
    <main-steps :step="step"/>
  </div>
</template>

<script>
import MainMenu from '@/components/_shared/main-menu'
import MainSteps from '@/components/_shared/main-steps'
import AppGuards from '@/guards/app.guards'

/**
   * 'App' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'App',
  components: {MainMenu, MainSteps},
  computed: {
    step () {
      return this.$store.getters['app/step']
    }
  },
  beforeRouteEnter: AppGuards.loadCatalogs
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .app {
    width: 100vw;
    height: 100vh;
    position: absolute;
    z-index: 1000;
    background-image: url(~/static/5c2523aa4fdbba1f26bf1750_master.jpg);
    background-position: center center;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/app.vue